export const rewards = {
  1714003200: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': {
      symbol: 'USDT-USDC-suUSD',
      token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
      tokenSymbol: 'MTRG-wstMTRG',
      gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
      rate: BigInt('124680000000000000000') / BigInt('604800'),
      period_finish: 0,
      decimals: 18,
    },
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': {
      symbol: '50MTRG-USDT-suUSD-USDC',
      token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
      tokenSymbol: 'MTRG-wstMTRG',
      gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
      rate: BigInt('124680000000000000000') / BigInt('604800'),
      period_finish: 0,
      decimals: 18,
    },
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': {
      symbol: '50ETH-50wstMTRG',
      token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
      tokenSymbol: 'MTRG-wstMTRG',
      gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
      rate: BigInt('62340000000000000000') / BigInt('604800'),
      period_finish: 0,
      decimals: 18,
    },
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': {
      symbol: 'MTRG-wstMTRG',
      token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
      tokenSymbol: 'MTRG-wstMTRG',
      gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
      rate: BigInt('374040000000000000000') / BigInt('604800'),
      period_finish: 0,
      decimals: 18,
    },
  },
  1714608000: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': {
      symbol: 'USDT-USDC-suUSD',
      token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
      tokenSymbol: 'MTRG-wstMTRG',
      gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
      rate: BigInt('93510000000000000000') / BigInt('604800'),
      period_finish: 0,
      decimals: 18,
    },
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': {
      symbol: '50MTRG-USDT-suUSD-USDC',
      token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
      tokenSymbol: 'MTRG-wstMTRG',
      gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
      rate: BigInt('93510000000000000000') / BigInt('604800'),
      period_finish: 0,
      decimals: 18,
    },
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': {
      symbol: '50ETH-50wstMTRG',
      token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
      tokenSymbol: 'MTRG-wstMTRG',
      gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
      rate: BigInt('62340000000000000000') / BigInt('604800'),
      period_finish: 0,
      decimals: 18,
    },
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': {
      symbol: 'MTRG-wstMTRG',
      token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
      tokenSymbol: 'MTRG-wstMTRG',
      gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
      rate: BigInt('374040000000000000000') / BigInt('604800'),
      period_finish: 0,
      decimals: 18,
    },
  },
  1715212800: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': [
      {
        symbol: 'USDT-USDC-suUSD',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
        rate: BigInt('93413872500000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': [
      {
        symbol: '50MTRG-USDT-suUSD-USDC',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
        rate: BigInt('93413872500000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': [
      {
        symbol: '50ETH-50wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
        rate: BigInt('62275915000000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': [
      {
        symbol: 'MTRG-wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
        rate: BigInt('373655490000000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
  },
  1715817600: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': [
      {
        symbol: 'USDT-USDC-suUSD',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
        rate: BigInt('140221149375000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': [
      {
        symbol: '50MTRG-USDT-suUSD-USDC',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
        rate: BigInt('140221149375000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': [
      {
        symbol: '50ETH-50wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
        rate: BigInt('93480766250000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': [
      {
        symbol: 'MTRG-wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
        rate: BigInt('560884597500000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
  },
  1716422400: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': [
      {
        symbol: 'USDT-USDC-suUSD',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
        rate: BigInt('140221149375000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': [
      {
        symbol: '50MTRG-USDT-suUSD-USDC',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
        rate: BigInt('140221149375000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': [
      {
        symbol: '50ETH-50wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
        rate: BigInt('93480766250000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': [
      {
        symbol: 'MTRG-wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
        rate: BigInt('560884597500000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
  },
  1717027200: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': [
      {
        symbol: 'USDT-USDC-suUSD',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
        rate: BigInt('140221149375000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': [
      {
        symbol: '50MTRG-USDT-suUSD-USDC',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
        rate: BigInt('140221149375000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': [
      {
        symbol: '50ETH-50wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
        rate: BigInt('93480766250000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': [
      {
        symbol: 'MTRG-wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
        rate: BigInt('560884597500000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
  },
  1717632000: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': [
      {
        symbol: 'USDT-USDC-suUSD',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
        rate: BigInt('140221149375000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': [
      {
        symbol: '50MTRG-USDT-suUSD-USDC',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
        rate: BigInt('140221149375000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': [
      {
        symbol: '50ETH-50wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
        rate: BigInt('93480766250000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': [
      {
        symbol: 'MTRG-wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
        rate: BigInt('560884597500000000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
  },
  1718236800: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': [
      {
        symbol: 'USDT-USDC-suUSD',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
        rate: BigInt('133916523464631000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': [
      {
        symbol: '50MTRG-USDT-suUSD-USDC',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
        rate: BigInt('133916523464631000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': [
      {
        symbol: '50ETH-50wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
        rate: BigInt('89277682309754100000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': [
      {
        symbol: 'MTRG-wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
        rate: BigInt('535666093858524000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
  },
  1719446400: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': [
      {
        symbol: 'USDT-USDC-suUSD',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
        rate: BigInt('133916523464631000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': [
      {
        symbol: '50MTRG-USDT-suUSD-USDC',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
        rate: BigInt('133916523464631000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': [
      {
        symbol: '50ETH-50wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
        rate: BigInt('89277682309754100000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': [
      {
        symbol: 'MTRG-wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
        rate: BigInt('535666093858524000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
  },
  1720051200: {
    '0x1ff97abe4c5a4b7ff90949b637e71626bef0dcee000000000000000000000002': [
      {
        symbol: 'USDT-USDC-suUSD',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x59f5a4c2d848c172c88118010019cf9297aacee6',
        rate: BigInt('133916523464631000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0xd9fe77653c2b75cf3442c365a3f1f9c7ed1612c7000200000000000000000003': [
      {
        symbol: '50MTRG-USDT-suUSD-USDC',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x63f9d4a03a58d1a329a3a1393a9a1e5525eb65a1',
        rate: BigInt('133916523464631000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x6e1be32644975613212db00bb9762fb6755ab921000200000000000000000007': [
      {
        symbol: '50ETH-50wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x8be2035d45f31b9827af789f6d4f8ce460372b2c',
        rate: BigInt('89277682309754100000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
    '0x2077a828fd58025655335a8756dbcfeb7e5bec46000000000000000000000008': [
      {
        symbol: 'MTRG-wstMTRG',
        token: '0x2077a828fd58025655335a8756dbcfeb7e5bec46',
        tokenSymbol: 'MTRG-wstMTRG',
        gauge: '0x0e533ff0486f8372096e889efdf71b323ed4f545',
        rate: BigInt('535666093858524000000') / BigInt('604800'),
        period_finish: 0,
        decimals: 18,
      },
    ],
  },
};
